export default "__VITE_ASSET__23ae20a8__"